import { MapPin, AlertCircle } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";

interface Job {
  id: string;
  job_number: string | null;
  property_address: string;
  status: string;
}

interface UnassignedJobsProps {
  jobs: Job[];
  onAssignClick: (jobId: string) => void;
}

export function UnassignedJobs({ jobs, onAssignClick }: UnassignedJobsProps) {
  const unassignedJobs = jobs.filter(job => job.status !== "completed");

  if (unassignedJobs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <AlertCircle className="w-10 h-10 text-muted-foreground mb-2" />
        <p className="text-sm text-muted-foreground">All jobs assigned</p>
      </div>
    );
  }

  return (
    <ScrollArea className="h-[280px]">
      <div className="space-y-2 pr-4">
        {unassignedJobs.map((job) => (
          <div 
            key={job.id}
            className="premium-card p-3 hover:border-primary/40 transition-colors"
          >
            <div className="flex items-start justify-between gap-2">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <Badge variant="secondary" className="text-xs">
                    {job.job_number || "N/A"}
                  </Badge>
                  <Badge variant="outline" className="text-xs">
                    {job.status}
                  </Badge>
                </div>
                <div className="flex items-center gap-1 text-xs text-muted-foreground">
                  <MapPin className="w-3 h-3 flex-shrink-0" />
                  <span className="truncate">{job.property_address}</span>
                </div>
              </div>
              <Button 
                size="sm" 
                variant="outline"
                className="text-xs"
                onClick={() => onAssignClick(job.id)}
              >
                Assign
              </Button>
            </div>
          </div>
        ))}
      </div>
    </ScrollArea>
  );
}
